/// <reference types="@types/googlemaps" />

import {Component, OnInit} from '@angular/core';

import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';

import {Router} from '@angular/router';

import {TranslateService} from '@ngx-translate/core';
import {AnalysisService} from '../services/analysis.service';

import {ToastrService} from 'ngx-toastr';

import {ModalReadMDIComponent} from '../modal-read-mdi/modal-read-mdi.component';
import {ModuleService} from '../services/module.service';
import {ITimelineItem} from '../interfaces/timelineItem';
import {ITimeline} from '../interfaces/timeline';

@Component({
  selector: 'app-mdi',
  templateUrl: './mdi.component.html',
  styleUrls: ['./mdi.component.css']
})
export class MdiComponent implements OnInit {

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private translate: TranslateService,
    private analysisService: AnalysisService,
    private moduleService: ModuleService,
    private toastr: ToastrService,
    private modal: NgbActiveModal,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    this.matIconRegistry.addSvgIcon('back', this.domSanitizer.bypassSecurityTrustResourceUrl(this.homeImage));
    this.matIconRegistry.addSvgIcon('all', this.domSanitizer.bypassSecurityTrustResourceUrl(this.summaryImage));
    this.matIconRegistry.addSvgIcon('Analysis', this.domSanitizer.bypassSecurityTrustResourceUrl(this.analysisImage));
    this.matIconRegistry.addSvgIcon('MDI', this.domSanitizer.bypassSecurityTrustResourceUrl(this.mdiImage));
    this.matIconRegistry.addSvgIcon('PPR', this.domSanitizer.bypassSecurityTrustResourceUrl(this.pprImage));
    this.matIconRegistry.addSvgIcon('ROI', this.domSanitizer.bypassSecurityTrustResourceUrl(this.roiImage));
  }

  // LocalStorage Elements.
  localFacilities = localStorage.getItem('localFacilities');
  localID = localStorage.getItem('localID');
  localModules = localStorage.getItem('localModules');

  timelineMessage = '';

  id = JSON.parse(this.localID);
  facilities = JSON.parse(this.localFacilities);
  modules = JSON.parse(this.localModules);
  currentFacility = this.facilities[this.id];

  // Icon NavBar
  markerImage: any = require('../image/logo/locationIcon.png');
  homeImage: any = require('../image/navbar/backHomeIcon.svg');
  summaryImage: any = require('../image/navbar/summary.svg');
  analysisImage: any = require('../image/navbar/analysis.svg');
  roiImage: any = require('../image/navbar/roi.svg');
  mdiImage: any = require('../image/navbar/mdi.svg');
  pprImage: any = require('../image/navbar/ppr.svg');

  lng: any;
  lat: any;
  zoom: number;

  timeline: ITimeline;

  itemTimeline: Array<ITimelineItem> = [];
  currentPage = 0;
  itemsNumberPerPage = 10;

  modalReference: any;

  partialState: null;
  notStartedState: null;

  analysisStatus = null;

  isOpen: boolean;
  _opened = false;

  reportAnalisysStus: boolean;
  idElaboration: number;
  reportAnalisysDate: Date;
  modelInterventDate: string;

  planMDi: any;
  module = 'MDI';

  ngOnInit() {

    this.translate.use(localStorage.getItem('localLanguage'));

    this.createGoogleMap();

    this.getTimeline(this.currentPage);

  }

  _toggleSidebar() {
    this._opened = !this._opened;
  }

  cardStructureOpen() {
    this.isOpen = true;
  }

  cardStructureClose() {
    this.isOpen = false;
  }

  // Method used to create a map of current Structure.
  createGoogleMap() {
    if (navigator) {
      this.lng = this.currentFacility.myFacilities.Longitude;
      this.lat = this.currentFacility.myFacilities.Latitude;
      this.zoom = 13;
    }
  }

  // Method used to scrolled Timline of current facility.
  onScroll(event) {
    if ((event.target.scrollHeight - event.target.scrollTop) === event.target.clientHeight) {
      if ((this.timeline.currentPage + 1) * this.timeline.requestItemsNumberPerPage < this.timeline.totalItemsCount) {
        this.currentPage++;
        this.getTimeline(this.currentPage);
      }
    }
  }

  // API Return Timeline
  getTimeline(currentPage: number) {
    // Call Api of Analys service to get Timeline of current facility.
    this.analysisService.getTimeline(this.currentFacility.myFacilities.IdAnalysis, this.modules, currentPage, this.itemsNumberPerPage)
      .subscribe(
        data => {
          this.timeline = data;

          for (const item of this.timeline.items) {
            this.itemTimeline.push(item);
          }

          this.checkedRequest();
          this.checkReportStatus(this.timeline);
        },
        error => {
          this.timelineMessage = error.error;
          // this.router.navigate(['/errorPage']);
        }
      );
  }


  // Method that checked request
  checkedRequest() {
    this.moduleService.ceckRequest(this.module, this.currentFacility.myFacilities.IdAnalysis)
      .subscribe(
        data => {
          this.reportAnalisysStus = true;
        },
        error => {
          if (error.status === 409) {
            this.reportAnalisysStus = false;
          } else {
            this.router.navigate(['/errorPage']);
          }
        });
  }

  // Method that check last item of timeline with state: Report.
  checkReportStatus(timeline: any) {
    for (const itemTimeline of timeline.items) {
      if ((itemTimeline.state === 'Pubblicato' || itemTimeline.state === 'Concluso' || itemTimeline.state === 'Eseguito')
        && itemTimeline.module === 'MDI') {
        this.idElaboration = itemTimeline.idElaborazioneRef;
        this.modelInterventDate = itemTimeline.timestamp;
        break;
      }
    }
  }

  // Method used to open Modal of Request MDI.
  openVerticallyCentered(content) {
    this.modalReference = this.modalService.open(content, {centered: true});
  }

  // Method used to close Modal of Request MDI.
  close() {
    this.modalReference.close();
  }


  mdiRequest() {
    this.moduleService.moduleRequest(this.module, this.currentFacility.myFacilities.ID, this.idElaboration)
      .subscribe(
        data => {
          this.currentPage = 0;
          this.itemTimeline = [];
          this.getTimeline(this.currentPage);
          this.close();
        },
        error => {
          this.router.navigate(['/errorPage']);
        });
  }

  // Open modal Read MDI
  mdiRead(idElaborazioneRef) {
    this.moduleService.moduleRead(this.currentFacility.myFacilities.ID, idElaborazioneRef, this.module)
      .subscribe(
        data => {
          this.planMDi = data;
          const modalRef = this.modalService.open(ModalReadMDIComponent, {centered: true, size: 'lg'});
          modalRef.componentInstance.planMDI = this.planMDi;
          modalRef.componentInstance.idElaboration = idElaborazioneRef;
        },
        error => {
          this.router.navigate(['/errorPage']);
        });
  }
}
